import React, { useState, useCallback } from "react";

interface Props {
    defaultLogo: string;
    onChangeLogo: (logo: File) => void;
}
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 Mo
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

export const SimpleImageUploader: React.FC<Props> = ({ defaultLogo, onChangeLogo }) => {
    const [preview, setPreview] = useState<string | null>(defaultLogo ?? null);
    const [isValid, setIsValid] = useState<boolean>(true);
    const [errorMessage, setErrorMessage] = useState<string>('');

  

    const handleImageUpload = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.currentTarget.files?.[0];

        setIsValid(true);
        setErrorMessage('');

        if (!file) {
            setErrorMessage('Aucun fichier sélectionné');
            setIsValid(false);
            return;
        }

        if (!ALLOWED_TYPES.includes(file.type)) {
            setErrorMessage('Format de fichier non supporté. Utilisez JPEG, PNG, GIF ou WEBP');
            setIsValid(false);
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            setErrorMessage('Fichier trop volumineux. Taille maximale : 5 Mo');
            setIsValid(false);
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const result = e.target?.result;

            if (typeof result === 'string') {
                setPreview(result);
                onChangeLogo(file);
            }
        };

        reader.onerror = () => {
            setErrorMessage('Erreur de lecture du fichier');
            setIsValid(false);
        };

        reader.readAsDataURL(file);
    }, [onChangeLogo]);

    return (
        <div className="space-y-4">
            <input
                type="file"
                accept="image/jpeg,image/png,image/gif,image/webp"
                onChange={handleImageUpload}
                className="file-input file-input-sm 
                file-input-primary file-input-bordered w-full max-w-xs"
            />

            {
                errorMessage && !isValid && (
                    <div className="text-red-500 text-sm mt-2">
                        {errorMessage}
                    </div>
                )
            }

            {
                preview && (
                    <div className="flex items-center space-x-6 mt-4 overflow-x-scroll">
                        <div className="border border-gray-300 w-[80px] h-[80px] rounded-full overflow-hidden">
                            <img
                                src={preview}
                                alt="Logo Preview"
                                className="object-cover w-full h-full"
                            />
                        </div>
                    </div>
                )
            }
        </div>
    );
};

